import React from "react";
import { Navigate } from "react-router-dom";
import { Preloader } from "../../shared";

/**
 * Route-level access gate.
 *
 * Deliberately generic - it takes the verdict as props rather than reading any
 * store, so `core` never depends on a feature block. The caller supplies the
 * rule (see RequireAuth in src/routesConfig.jsx), which is also the seam for
 * role-based access later: pass `isAllowed={user.role === "admin"}`.
 *
 * @param {Object} props
 * @param {boolean} props.isAllowed   whether the visitor may see `children`
 * @param {boolean} [props.isLoading] true while the verdict is still unknown
 * @param {string}  [props.redirectTo] path to send disallowed visitors to
 * @param {React.ReactNode} [props.fallback] shown while loading
 * @param {React.ReactNode} props.children
 */
const ProtectedRoute = ({
  isAllowed,
  isLoading = false,
  redirectTo = "/",
  fallback = <Preloader />,
  children,
}) => {
  // Wait for the verdict before acting. Redirecting on a not-yet-known value
  // bounces a signed-in visitor to the login page for one frame on every reload.
  if (isLoading) return fallback;
  if (!isAllowed) return <Navigate to={redirectTo} replace />;

  return children;
};

export default ProtectedRoute;
